<template>
  <div class="content-wrap">
    <div class="bm_left">
      <h2 class="bm_title">客户信息分类</h2>
      <div class="bm_box">
        <el-input v-model.trim="treeInfo.search" :readonly="true" placeholder="请输入">
          <template #append>
            <el-button plain icon="search" @click="warn"></el-button>
          </template>
        </el-input>
        <div class="bm_tree-box">
          <div class="bm_fenlei">
            <el-icon class="caret"><CaretRight /></el-icon>
            <p class="bm_fenlei_title" @click="nodeClick()">客户信息分类</p>
            <el-dropdown>
              <el-icon><Plus /></el-icon>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <el-button type="default" @click="addCategory">增加</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="bm_tree">
            <ul>
              <li class="tree_li" v-for="item in treeData" :key="item.id">
                <div :class="['tree-node', treeInfo.id == item.id ? 'active' : '']">
                  <p style="width: 100%; padding: 0 10px" @click="nodeClick(item)">{{ item.name }}</p>
                  <el-dropdown>
                    <el-icon><MoreFilled /></el-icon>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item @click="reNameCategroy(item)"><span>重命名</span></el-dropdown-item>
                        <el-dropdown-item @click="warn"><span>删除</span></el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="bm_right">
      <h3 class="bm_mc">{{ treeInfo.id ? treeInfo.selectTxt : '客户信息分类' }}</h3>
      <el-form :model="queryParams" :inline="true" label-width="140" class="search-box">
        <el-form-item label="客户名称">
          <el-input v-model.trim="queryParams.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model.trim="queryParams.taxRegistrationNo" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="简码">
          <el-input v-model.trim="queryParams.shortCode" placeholder="请输入" />
        </el-form-item>
      </el-form>

      <div style="box-sizing: border-box; width: 100%; padding: 0px 20px; margin-top: 30px; display: flex; justify-content: end">
        <el-button type="default" @click="warn">重置</el-button>
        <el-button type="primary" @click="warn">查询</el-button>
      </div>

      <div style="box-sizing: border-box; width: 100%; margin-top: 30px; display: flex">
        <el-button type="primary" icon="plus" @click="addBuyer">添加</el-button>
        <el-button type="default" @click="warn">批量导入</el-button>
        <el-button type="default" @click="warn">税控批量导入</el-button>
        <el-dropdown style="margin-left: 10px">
          <el-button type="default">
            更多操作
            <el-icon><CaretBottom /></el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="delBatchBuyer"><span>批量删除</span></el-dropdown-item>
              <el-dropdown-item @click="warn"><span>导出</span></el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>

      <div class="table-container">
        <el-table :data="tableData" :border="true"
                  ref="tableRef"
        >
          <template v-if="!isSelected">
            <el-table-column type="selection" align="center" width="55" />
          </template>
          <el-table-column label="序号" type="index" width="55" />
          <el-table-column label="客户名称" prop="name" min-width="150" />
          <el-table-column label="统一社会信用代码/纳税人识别号" prop="taxRegistrationNo" min-width="150" />
          <el-table-column label="简码" prop="shortCode" min-width="150" />
          <el-table-column label="地址" prop="address" :formatter="formatCell" min-width="150" />
          <el-table-column label="联系电话" prop="phone" :formatter="formatCell" min-width="120" />
          <el-table-column label="开户行名称" prop="bank" :formatter="formatCell" min-width="150" />
          <el-table-column label="银行账号" prop="account" :formatter="formatCell" min-width="150" />
          <el-table-column label="联系邮箱" prop="email" :formatter="formatCell" min-width="150" />
          <template v-if="!isSelected">
            <el-table-column label="操作" fixed="right" width="170">
              <template #default="{ row }">
                <div>
                  <el-button type="primary" link @click="checkDetail(row)">详情</el-button>
                  <el-button type="primary" link @click="modifyBuyer(row)">修改</el-button>
                  <el-button type="primary" link @click="delBuyer(row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column label="操作" fixed="right" width="60">
              <template #default="{ row }">
                <div>
                  <el-button type="primary" link @click="selectRow(row)">选取</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>

    <!--新增/修改分类  -->
    <el-dialog v-model="dialog.open" width="480" :title="dialog.title" draggable>
      <div class="dialog-body">
        <div style="margin-top: 30px" v-if="!dialog.formData.id">
          <p style="line-height: 30px; font-size: 14px; color: #333">客户信息分类节点</p>
          <p style="line-height: 30px; font-size: 14px; color: #333">客户信息分类</p>
        </div>
        <el-form :model="dialog.formData" label-position="top" @submit.prevent style="margin-top: 30px">
          <el-form-item label="分类名称" prop="name" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <el-input v-model.trim="dialog.formData.name" placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div>
          <el-button type="default" @click="dialog.open = false">取消</el-button>
          <el-button type="primary" @click="saveCategroy">保存</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog v-model="showDetail" width="786" title="详情" draggable class="detail-box">
      <div style="box-sizing: border-box; width: 100%; padding: 10px; background-color: #f9fafd">
        <el-row>
          <el-col>
            <span> 客户分类: </span>
            <span>{{ `客户信息分类/${currentRow.categoryName}` }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span> 客户名称: </span>
            <span>{{ currentRow.name }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span> 统一社会信用代码: </span>
            <span>{{ currentRow.taxRegistrationNo }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span> 简码: </span>
            <span>{{ currentRow.shortCode }}</span>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <el-button type="default" @click="showDetail = false">关闭</el-button>
      </template>
    </el-dialog>
    <!-- 添加/修改客户 -->
    <kh-drawer v-model="show" :row="currentRow" @refresh="getList" />
  </div>
</template>

<script setup name="Maintence/khbm">
import { ElMessageBox, ElMessage } from 'element-plus';
import khDrawer from './khDrawer.vue';
import useInvoiceStore from '@/store/modules/invoice';
const useInvoice = useInvoiceStore();
const props = defineProps({
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['confirm']);

//树数据
const treeInfo = reactive({
  search: undefined,
  selectTxt: '',
  id: undefined,
});

const treeData = ref([]);

//弹框
const dialog = reactive({
  open: false,
  title: '',
  formData: {
    name: undefined,
    id: undefined,
  },
});
const queryParams = ref({});

const tableData = ref([]);

//抽屉
const show = ref(false);
const currentRow = ref({});

const showDetail = ref(false);

onMounted(() => {
  getTreeData();
  getList();
});

//获取分类树
function getTreeData() {
  const data = useInvoice.buyerCategory;
  treeData.value = [...toRaw(data)];
}

//获取项目数据
function getList() {
  const data = useInvoice.buyerList;
  if (treeInfo?.id) {
    tableData.value = [...toRaw(data)].filter((item) => item.categoryId == treeInfo.id);
  } else {
    tableData.value = [...toRaw(data)];
  }
}

//警告功能
function warn() {
  ElMessageBox.confirm('本系统为教学系统，暂不支持此功能', '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {});
}

//添加种类
function addCategory() {
  dialog.open = true;
  dialog.title = '新增分类';
  Object.assign(dialog.formData, { name: undefined, id: '' });
}

//重命名种类
function reNameCategroy(data) {
  dialog.open = true;
  dialog.title = '重命名';
  Object.assign(dialog.formData, { name: data.name, id: data.id });
}

//保存项目种类
function saveCategroy() {
  if (!dialog.formData.name) return;
  if (dialog.formData.id) {
    useInvoice.updateBuyerCategroy(dialog.formData);
  } else {
    useInvoice.addBuyerCategroy(dialog.formData);
  }
  getTreeData();
  dialog.open = false;
}

//点击商品分类
function nodeClick(data) {
  if (!data) {
    treeInfo.id = undefined;
  } else {
    if (treeInfo.id !== data.id) {
      treeInfo.id = data.id;
      treeInfo.selectTxt = data.name;
    }
  }
  getList();
}

//添加分类客户类型
function addBuyer() {
  if (!treeInfo.id) {
    ElMessage({
      message: '请选择客户信息分类',
      type: 'warning',
      customClass: 'message',
    });
    return;
  }
  show.value = true;
  currentRow.value = {};
  currentRow.value.categoryName = treeInfo.selectTxt;
  currentRow.value.categoryId = treeInfo.id;
}

//修改客户分类
function modifyBuyer(data) {
  show.value = true;
  currentRow.value = Object.assign({}, toRaw(data));
}

// 删除客户
function delBuyer(row) {
  ElMessageBox.confirm("确认删除本条数据?", "提示")
      .then(() => {
        useInvoice.delBuyer([row.id])
        getList()
      })
      .catch(() => {
      })
}

const tableRef = ref()

function delBatchBuyer() {
  const selectRows = tableRef.value.getSelectionRows();
  if (!selectRows.length) {
    return ElMessage({
      message: "请选择数据，再批量删除",
      type: "warning",
    });
  }
  ElMessageBox.confirm("确认删除选中的数据?", "提示")
      .then(() => {
        useInvoice.delBuyer(selectRows.map(m => m.id))
        getList()
      })
      .catch(() => {
      })
}

//格式化表格内容
function formatCell(row, column, cellValue) {
  const bankInfo = row.bankInfoList.find((item) => item.isDefault === 1);
  return bankInfo ? bankInfo[column.property] : '';
}

//查看详情
function checkDetail(data) {
  showDetail.value = true;
  currentRow.value = Object.assign({}, data);
}

//点击选择按钮
function selectRow(row) {
  emits('confirm', row);
}
</script>

<style lang="scss" scoped>
.content-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  .bm_left {
    flex: none;
    width: 260px;
    border-right: 1px solid #eee;
    .bm_title {
      box-sizing: border-box;
      width: 100%;
      height: 60px;
      padding-left: 20px;
      line-height: 60px;
      border-bottom: 1px solid #eee;
      font-size: 18px;
      color: #333;
    }
    .bm_box {
      box-sizing: border-box;
      width: 100%;
      padding: 10px;
      .bm_tree-box {
        width: 100%;
        margin-top: 10px;
        overflow-y: auto;
        cursor: pointer;
        .bm_fenlei {
          position: relative;
          padding-left: 14px;
          line-height: 24px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .bm_fenlei_title {
            box-sizing: border-box;
            width: fit-content;
            padding: 0 10px;
            font-size: 14px;
            font-weight: 400;
          }
          .caret {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(-50%, -50%);
            line-height: 24px;
          }
        }
        .bm_tree {
          width: 100%;
          > ul {
            padding-left: 16px;
            .tree_li {
              padding-left: 10px;
              font-size: 12px;
              .tree-node {
                box-sizing: border-box;
                width: 100%;
                height: 28px;
                line-height: 28px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                &.active {
                  > p {
                    background-color: #ecf2fe;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .bm_right {
    flex: auto;
    box-sizing: border-box;
    padding-left: 20px;
    overflow-y: auto;
    .bm_mc {
      height: 60px;
      line-height: 60px;
      font-size: 18px;
      color: #333;
    }
    :deep(.search-box) {
      width: 100%;
      .el-form-item {
        margin-right: 0;
        .el-form-item__label {
          white-space: nowrap;
        }
        .el-form-item__content {
          > .el-input,
          .el-select {
            width: 300px;
          }
        }
      }
    }
    .table-container {
      width: 100%;
      margin-top: 10px;
    }
  }
}

:deep(.detail-box) {
  .el-dialog__body {
    .el-row .el-col {
      font-size: 14px;
      line-height: 40px;
      > span {
        &:first-child {
          color: #666;
        }
        &:last-child {
          margin-left: 5px;
          color: #333;
        }
      }
    }
  }
}
:global(.message) {
  .el-icon {
    font-size: 14px;
  }
}
</style>
